import React, { useMemo, useState } from "react";
import { Image, Modal, Table, Tooltip } from "antd";
import { useSelector } from "react-redux";
import NoGraphData from "../workspace/DisplayChart/NoGraphData";
import { CaretUpFilled, CaretDownFilled } from "@ant-design/icons";
import { isString } from "@microsoft/applicationinsights-core-js";
import { isNumber } from "highcharts";
import isEqual from "react-fast-compare";
import defaultImage from "../../assets/brandLogos/Default_Brand.svg";
import deepLinkIcon from "../../assets/deepLink_Icon.svg";
import openMediaAttachment from "../../assets/open_media_file.svg";
import Profile from "../../assets/Profile_Pic.svg";
import fx from "../../assets/WidgetMaker/FX.svg";
import Default_Brand from "../../assets/brandLogos/Default_Brand.svg";
import verified from "../../assets/verified.svg";
import IsDarkPost from "../../assets/Dark_Post.svg";
import promoted from "../../assets/boosted_post_icon.svg";
import { SocialMedialogo } from "../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import { deepCopy, formatDuration, kFormatter } from "../../redux/constants";
import { getCountryLogo, getGenderLogo } from "../utils/Logos";
import config1 from "../../config";
import PostCardDetails from "./PostCardDetails";
const { Column } = Table;

const PostCardGrid = ({
  tableColumns,
  dataSource,
  colors,
  PdfDownloadStatus,
  metadata,
  noteExist,
  insightsExist,
  tree_grid,
  grand_total,
  widgetDurationComparisonForChart,
  widgetDurationDataForChart,
  rowSpanOn,
  hideColumns,
  hideSorting,
  dateLabels,
  hidePagination,
  widgetContainerHeight,
  hideSortingOption,
  data,
  isPreviewState,
  PptGeneratingStatus,
  isCommandCenterScreen,
  deepDive,
  isDeepDiveDashboardView = false,
}) => {
  const [scrollAbleTable, setScrollAbleTable] = useState(0);
  const [paginationInfo, setPaginationInfo] = useState({
    current: 1,
    pageSize: scrollAbleTable,
  });
  const [deepLinkModal, setDeepLinkModal] = useState({
    url: null,
    modalShow: false,
  });
  const [pdfView, setPdfView] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalLoader, setIsModalLoader] = useState(false);
  const [modalData, setIsModalData] = useState(null);
  const widgetGraphConfig = useSelector(
    (state) => state.GraphConfig.widgetGraphConfig
  );
  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  let datasourceu = [];
  let tableKey = [];
  const getTableColumnsWithSorting = (columns) => {
    columns = columns
      ?.map((column, i) => {
        let isHiddenColumn =
          hideColumns && Array.isArray(hideColumns)
            ? hideColumns?.includes(column?.title || column?.dataIndex)
            : false;
        if (column?.title === "row_span" || isHiddenColumn) return null;
        if (column?.children?.length) {
          setPdfView(true);
          column.children = getTableColumnsWithSorting(column?.children);
        } else {
          column.key = column?.title + "_" + i;
          let isSortHidden = hideSortingOption
            ? hideSortingOption
            : hideSorting && Array.isArray(hideSorting)
            ? hideSorting?.includes(column?.title || column?.dataIndex)
            : false;
          if (!rowSpanOn && !isSortHidden) {
            column.sorter = (a, b) => {
              if (a[column?.dataIndex]) {
                let aData =
                  a[column?.dataIndex]?.value !== null &&
                  a[column?.dataIndex]?.value !== undefined
                    ? a[column?.dataIndex]?.value
                    : a[column?.dataIndex];
                let bData =
                  b[column?.dataIndex]?.value !== null &&
                  b[column?.dataIndex]?.value !== undefined
                    ? b[column?.dataIndex]?.value
                    : b[column?.dataIndex];
                if (aData?.props?.children?.[1]) {
                  aData = aData?.props?.children?.[1];
                }
                if (bData?.props?.children?.[1]) {
                  bData = bData?.props?.children?.[1];
                }
                if (isString(aData) && isString(bData)) {
                  if ((a?.total_flag || b?.total_flag) && grand_total) return 0;
                  else return aData?.localeCompare(bData);
                } else if (
                  (isString(aData) && isNumber(bData)) ||
                  (isNumber(aData) && isString(bData))
                ) {
                  if ((a?.total_flag || b?.total_flag) && grand_total) return 0;
                  else return isString(aData) && isNumber(bData) ? -1 : 1;
                } else {
                  if ((a?.total_flag || b?.total_flag) && grand_total) return 0;
                  else return aData - bData;
                }
              } else {
                let aData =
                  a[column?.title]?.value !== null &&
                  a[column?.title]?.value !== undefined
                    ? a[column?.title]?.value
                    : a[column?.title];
                let bData =
                  b[column?.title]?.value !== null &&
                  b[column?.title]?.value !== undefined
                    ? b[column?.title]?.value
                    : b[column?.title];
                if (aData?.props?.children?.[1]) {
                  aData = aData?.props?.children?.[1];
                }
                if (bData?.props?.children?.[1]) {
                  bData = bData?.props?.children?.[1];
                }
                if (isString(aData) && isString(bData)) {
                  if ((a?.total_flag || b?.total_flag) && grand_total) return 0;
                  else return aData?.localeCompare(bData);
                } else if (
                  (isString(aData) && isNumber(bData)) ||
                  (isNumber(aData) && isString(bData))
                ) {
                  if ((a?.total_flag || b?.total_flag) && grand_total) return 0;
                  else return isString(aData) && isNumber(bData) ? -1 : 1;
                } else {
                  if ((a?.total_flag || b?.total_flag) && grand_total) return 0;
                  else return aData - bData;
                }
              }
            };
          }
        }
        return column;
      })
      ?.filter((el) => el);
    return columns;
  };
  const getUpdatedDataSource = (sources) => {
    let updatedDataSource =
      sources && Array.isArray(sources) ? deepCopy(sources) : [];
    if (grand_total && updatedDataSource?.length)
      updatedDataSource[updatedDataSource?.length - 1].total_flag = true;
    if (updatedDataSource?.length) {
      updatedDataSource =
        sources &&
        sources.map((el, i) => {
          let columnNames = Object.keys(el);
          tableKey = columnNames;
          if (tree_grid) {
            if (columnNames?.length > 0) {
              let updatedEl = { ...el };
              columnNames?.forEach((c) => {
                let rowData = updatedEl?.[c];
                if (
                  typeof rowData === "string" &&
                  (rowData?.includes("|$|") ||
                    rowData?.includes("|G|") ||
                    rowData?.includes("|C|"))
                ) {
                  let channelImage =
                    isString(rowData) && rowData?.includes("|$|")
                      ? rowData?.split("|$|")?.[0]?.trim()
                      : null;
                  let ProfileName =
                    isString(rowData) && rowData?.includes("|$|")
                      ? rowData?.split("|$|")?.[1]?.trim()
                      : null;
                  let genderName =
                    isString(rowData) && rowData?.includes("|G|")
                      ? rowData?.split("|G|")?.[1]?.trim()
                      : null;
                  let countryName =
                    isString(rowData) && rowData?.includes("|C|")
                      ? rowData?.split("|C|")?.[1]?.trim()
                      : null;
                  if (channelImage && ProfileName) {
                    updatedEl[c] = (
                      <>
                        <img
                          style={{
                            width: "1.5rem",
                            height: "1.5rem",
                            margin: "0.5rem",
                          }}
                          src={
                            channelImage
                              ? SocialMedialogo?.[channelImage]
                              : defaultImage
                          }
                        />
                        {ProfileName}
                      </>
                    );
                  } else if (genderName) {
                    updatedEl[c] = (
                      <>
                        <img
                          style={{
                            width: "1.5rem",
                            height: "1.5rem",
                            margin: "0.5rem",
                          }}
                          src={getGenderLogo(genderName)}
                        />
                        {genderName}
                      </>
                    );
                  } else if (countryName) {
                    updatedEl[c] = (
                      <>
                        {getCountryLogo(countryName)}
                        {countryName}
                      </>
                    );
                  }
                } else if (c?.includes("Review Ratings")) {
                  updatedEl[c] = `${updatedEl[`Review Ratings`]} ⭐`;
                } else if (c?.includes("Rating")) {
                  updatedEl[c] = `${updatedEl[`Rating`]} ⭐`;
                }
              });
              return updatedEl;
            } else {
              return el;
            }
          } else if (columnNames?.includes("Review Ratings")) {
            return {
              ...el,
              [`Review Ratings`]: `${el[`Review Ratings`]} ⭐`,
            };
          } else if (columnNames?.includes("Rating")) {
            return { ...el, [`Rating`]: `${el[`Rating`]} ⭐` };
          } else {
            return el;
          }
        });

      if (PdfDownloadStatus) {
        if (noteExist && insightsExist && updatedDataSource?.length > 8)
          updatedDataSource = updatedDataSource?.slice(0, 8);
        else if (updatedDataSource?.length > 11)
          updatedDataSource = pdfView
            ? updatedDataSource?.slice(0, 9)
            : updatedDataSource?.slice(0, 11);
      }
    }
    return updatedDataSource;
  };
  const handleDeepLinkOk = () => {
    setDeepLinkModal({
      url: null,
      modalShow: false,
    });
  };
  const handleDeepLinkCancel = () => {
    setDeepLinkModal({
      url: null,
      modalShow: false,
    });
  };
  const onExternal = (TicketID, PostBrandID) => {
    setDeepLinkModal({
      url: null,
      modalShow: true,
    });
    let url =
      config1?.config1?.app_id === "10" || config1?.config1?.app_id === 10
        ? "https://preprodcx.locobuzz.com/ticketDetail"
        : config1?.config1?.app_id === "6" || config1?.config1?.app_id === 6
        ? window?.location?.origin?.includes("bbps.locobuzz.com") ||
          window?.location?.ancestorOrigins?.[0]?.includes("bbps.locobuzz.com")
          ? "https://bbps.locobuzz.com/ticketDetail"
          : "https://cx.locobuzz.com/ticketDetail"
        : config1?.config1?.app_id === "4" || config1?.config1?.app_id === 4
        ? window?.location?.origin?.includes("demo.locobuzz.com")
          ? "https://demo.locobuzz.com/ticketDetail"
          : window?.location?.origin?.includes(
              "locobuzzng-uat-aws.locobuzz.com"
            ) ||
            window?.location?.ancestorOrigins?.[0]?.includes(
              "locobuzzng-uat-aws.locobuzz.com"
            )
          ? "https://locobuzzng-uat-aws.locobuzz.com/ticketDetail"
          : "https://demo.locobuzz.com/ticketDetail"
        : "https://demo.locobuzz.com/ticketDetail";
    // : "https://demo.locobuzz.com/ticketDetail";

    let finalUrl = `${url}/${TicketID}/${PostBrandID}`;
    if (config1?.config1?.app_id === "2") {
      console.log("Deep Link URL =>", finalUrl);
    }
    // window.open(finalUrl);

    setDeepLinkModal({
      url: (
        <iframe
          title="Ticket Details"
          allowfullscreen={true}
          src={finalUrl}
          alt="Ticket Details"
          className="w-100 border-0 border-radius-4"
          style={{ height: "calc(100vh - 6.3rem)", marginTop: "3.7rem" }}
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        />
      ),
      modalShow: true,
    });
  };
  const showPostDetailsModal = (elementData) => {
    const ThreeDGlobalPage =
      (authParams?.screen_id === "000-000-555" ||
        authParams?.screen_id === "000-000-551" ||
        authParams?.screen_id === "000-000-557") &&
      !isDeepDiveDashboardView
        ? true
        : false;
    const updateData = ThreeDGlobalPage
      ? {
          ...elementData,
          isModalOpen: !isModalOpen,
        }
      : elementData;
    setIsModalLoader(true);
    setIsModalOpen(true);
    setIsModalData(updateData);
  };
  const getDefautBrandImg = (e) => {
    return (e.target.src = Default_Brand);
  };
  const getHtmlForThisColumn = (combinations, column, rowData, index) => {
    if (column?.title?.toLowerCase() === "Author"?.toLowerCase()) {
      return (
        <div className="cardList-head card-head h-100 d-flex justify-content-between align-items-top">
          {combinations?.includes("ProfilePicture") ? (
            <div
              className="position-relative mr-15"
              style={{ width: "3.5rem" }}
            >
              <Image
                src={
                  rowData?.ProfilePicture === 0 ||
                  rowData?.ProfilePicture === "" ||
                  !rowData?.ProfilePicture
                    ? Profile
                    : rowData?.ProfilePicture
                }
                fallback={Profile}
                preview={false}
                alt="Profile Images"
                className="profileImg m-0"
                style={{ width: "3.5rem", height: "3.5rem" }}
                crossOrigin="anonymous"
              />
              {combinations?.includes("PlatformID") ? (
                <div
                  className="position-absolute"
                  style={{
                    right: "-0.8rem",
                    top: "-0.4rem",
                  }}
                >
                  <Image
                    src={
                      rowData?.PlatformID === 0
                        ? Default_Brand
                        : SocialMedialogo?.[rowData?.PlatformID]
                        ? SocialMedialogo?.[rowData?.PlatformID]
                        : Default_Brand
                    }
                    alt="Channel"
                    preview={false}
                    fallback={Default_Brand}
                    style={{
                      width: "1.6rem",
                      maxHeight: "2rem",
                      verticalAlign: "top",
                    }}
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          {combinations?.includes("Author") ? (
            <div
              style={{ width: "calc(100% - 6rem)" }}
              className="m-auto text-left"
            >
              <div className="d-flex flex-wrap align-items-center">
                <Tooltip title={rowData?.["Author"]}>
                  <div
                    className="profileName text-ellipsis line-height-normal"
                    style={{
                      maxWidth:
                        typeof rowData?.["Is Verified"] === "boolean" &&
                        rowData?.["Is Verified"]
                          ? "calc(100% - 2.5rem)"
                          : "",
                    }}
                  >
                    {rowData?.["Author"]}
                  </div>
                </Tooltip>
                {combinations?.includes("Is Verified") &&
                typeof rowData?.["Is Verified"] === "boolean" &&
                rowData?.["Is Verified"] ? (
                  <img
                    src={verified}
                    alt="verified"
                    className="profileImg ml-1"
                    style={{ height: "1.6rem" }}
                  />
                ) : (
                  ""
                )}
              </div>
              {combinations?.includes("Screen Name") &&
              rowData?.["Screen Name"] ? (
                <div
                  className="screenName text-grayLight text-ellipsis w-100"
                  //style={{ width: "90%" }}
                >
                  <Tooltip title={rowData?.["Screen Name"]}>
                    {rowData?.["Screen Name"]}
                  </Tooltip>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
        </div>
      );
    } else if (column?.title?.toLowerCase() === "Brand"?.toLowerCase()) {
      return (
        <>
          <div className="cardList-head card-head h-100 d-flex justify-content-between align-items-center">
            {combinations?.includes("Brand") ? (
              <Image
                src={
                  rowData?.["Brand Logo"] && rowData?.["Brand Logo"] !== "NA"
                    ? rowData?.["Brand Logo"]
                    : Default_Brand
                }
                fallback={
                  rowData?.["Brand Logo"] && rowData?.["Brand Logo"] !== "NA"
                    ? rowData?.["Brand Logo"]
                    : Default_Brand
                }
                preview={false}
                alt="Brand logo"
                onError={getDefautBrandImg}
                className="profileImg mr-1"
                style={{
                  width: "3.5rem",
                  height: "3.5rem",
                  //marginTop: "-0.5rem",
                }}
                // crossOrigin="anonymous"
              />
            ) : (
              ""
            )}
            {rowData?.["Brand"]}
          </div>
        </>
      );
    } else if (column?.title?.toLowerCase() === "Mention"?.toLowerCase()) {
      return (
        <>
          {rowData?.["Mention"]?.length > 180
            ? rowData?.["Mention"]?.slice(0, 180)
            : rowData?.["Mention"]}
          {rowData?.["Mention"]?.length > 180 ? (
            <span
              className="blue-text cursor-pointer"
              onClick={() =>
                showPostDetailsModal(data?.length > 0 ? data?.[index] : null)
              }
            >
              ... Read More
            </span>
          ) : (
            ""
          )}
          {rowData?.["Attachments"]?.length > 0 ? (
            <span
              className="trands cursor-pointer"
              onClick={() =>
                showPostDetailsModal(data?.length > 0 ? data?.[index] : null)
              }
              style={{ width: "2.5rem" }}
            >
              <Tooltip
                title={
                  rowData?.["Attachments"]?.length > 1
                    ? "Open Attachments"
                    : "Open Attachment"
                }
              >
                <img
                  src={openMediaAttachment}
                  className="cardList__footer-label"
                  alt="Attachments"
                  style={{
                    maxWidth: "1.8rem",
                    width: "1.8rem",
                  }}
                />
              </Tooltip>
            </span>
          ) : (
            ""
          )}
        </>
      );
    } else if (column?.title?.toLowerCase() === "Engagement"?.toLowerCase()) {
      return (
        <div className="d-flex align-items-center justify-content-center">
          <Tooltip title={rowData?.["Engagement"]?.toLocaleString()}>
            <span className="mr-1">{kFormatter(rowData?.["Engagement"])} </span>
          </Tooltip>

          {combinations?.includes("engagement_fx") ? (
            <>
              {rowData?.engagement_fx ? (
                <Tooltip title={rowData?.["Engagement_text"]}>
                  <img
                    src={fx}
                    style={{ maxWidth: "1.5rem" }}
                    className="mr-1 cursor-pointer"
                    alt="fx"
                  />
                </Tooltip>
              ) : (
                ""
              )}{" "}
            </>
          ) : (
            ""
          )}
        </div>
      );
    } else if (column?.title?.toLowerCase() === "Reach"?.toLowerCase()) {
      return (
        <div className="d-flex align-items-center justify-content-center">
          <Tooltip title={rowData?.["Reach"]?.toLocaleString()}>
            <span className="mr-1">{kFormatter(rowData?.["Reach"])} </span>
          </Tooltip>

          {combinations?.includes("reach_fx") ? (
            <>
              {rowData?.reach_fx ? (
                <Tooltip title={rowData?.["Reach_text"]}>
                  <img
                    src={fx}
                    style={{ maxWidth: "1.5rem" }}
                    className="mr-1 cursor-pointer"
                    alt="fx"
                  />
                </Tooltip>
              ) : (
                ""
              )}{" "}
            </>
          ) : (
            ""
          )}
        </div>
      );
    } else if (column?.title?.toLowerCase() === "Impression"?.toLowerCase()) {
      return (
        <div className="d-flex align-items-center justify-content-center">
          <Tooltip title={rowData?.["Impression"]?.toLocaleString()}>
            <span className="mr-1">
              {kFormatter(rowData?.["Impression"], false, true)}{" "}
            </span>
          </Tooltip>

          {combinations?.includes("impression_fx") ? (
            <>
              {rowData?.impression_fx ? (
                <Tooltip title={rowData?.["Impression_text"]}>
                  <img
                    src={fx}
                    style={{ maxWidth: "1.5rem" }}
                    className="mr-1 cursor-pointer"
                    alt="fx"
                  />
                </Tooltip>
              ) : (
                ""
              )}{" "}
            </>
          ) : (
            ""
          )}
        </div>
      );
    }
    return <></>;
  };
  const updatedTableColumn = useMemo(
    () => getTableColumnsWithSorting(tableColumns),
    [tableColumns, tree_grid]
  );
  const updatedDataSource = useMemo(
    () => getUpdatedDataSource(dataSource),
    [dataSource]
  );
  return updatedTableColumn ? (
    <div
      id={`table_${metadata?.widget_id}`}
      className="widgetmaker-grid-chart p-15 w-100"
    >
      {tree_grid ? (
        <Table
          dataSource={updatedDataSource}
          columns={updatedTableColumn}
          //bordered
          className="custom_table_scroll"
          scroll={
            PdfDownloadStatus || metadata?.span === "one_third"
              ? {}
              : {
                  x: 1000,
                }
          }
          pagination={
            PdfDownloadStatus || hidePagination
              ? false
              : {
                  hideOnSinglePage:
                    updatedDataSource?.length > 10 ? false : true,
                  defaultPageSize: 10,
                  showSizeChanger:
                    metadata?.span === "one_third" ? false : true,
                  pageSizeOptions:
                    updatedDataSource?.length > 10 &&
                    updatedDataSource?.length <= 20
                      ? ["10", "20"]
                      : updatedDataSource?.length > 20 &&
                        updatedDataSource?.length <= 30
                      ? ["10", "20", "30"]
                      : updatedDataSource?.length > 30 &&
                        updatedDataSource?.length <= 40
                      ? ["10", "20", "30", "40"]
                      : ["10", "20", "30", "40", "50"],
                  locale: { items_per_page: "" },
                  total: updatedDataSource?.length,
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total}`,
                }
          }
        />
      ) : (
        <Table
          dataSource={updatedDataSource}
          className={`custom_table_scroll PostCard--grid
          ${rowSpanOn ? "antd_table-withborder" : ""}
          ${PdfDownloadStatus ? "" : "overflow_auto"} ${
            metadata?.span === "one_third" ? "one_third-grid" : ""
          }
          ${
            scrollAbleTable > 10 || rowSpanOn || PdfDownloadStatus
              ? ""
              : "table-cell-scrllbar-bg-none"
          }
          `}
          //bordered

          scroll={
            PdfDownloadStatus
              ? {}
              : hidePagination && widgetContainerHeight > 0
              ? updatedDataSource?.length > 8
                ? {
                    y:
                      widgetContainerHeight > 0
                        ? widgetContainerHeight -
                          (metadata?.widget_id === "000-100-961" ||
                          metadata?.widget_id === "000-100-962" ||
                          metadata?.widget_id === "000-100-963"
                            ? 0
                            : 60)
                        : 408,
                    x: "100%",
                  }
                : {
                    y:
                      widgetContainerHeight > 0
                        ? widgetContainerHeight -
                          (metadata?.widget_id === "000-100-961" ||
                          metadata?.widget_id === "000-100-962" ||
                          metadata?.widget_id === "000-100-963"
                            ? 0
                            : 40)
                        : 408,
                    x: "100%",
                  }
              : metadata?.span === "one_third" || scrollAbleTable < 11
              ? { y: "100%", x: "100%" }
              : scrollAbleTable > 10
              ? { y: 408, x: "100%" }
              : { y: "100%", x: "100%" }
          }
          onChange={(pagination, filters, sorter, extra) => {
            setScrollAbleTable(pagination?.pageSize);
            setPaginationInfo(pagination);
          }}
          pagination={
            PdfDownloadStatus || hidePagination
              ? false
              : {
                  hideOnSinglePage:
                    updatedDataSource?.length > 10 ? false : true,
                  defaultPageSize: 10,
                  showSizeChanger:
                    metadata?.span === "one_third" ? false : true,
                  pageSizeOptions:
                    updatedDataSource?.length > 10 &&
                    updatedDataSource?.length <= 20
                      ? ["10", "20"]
                      : updatedDataSource?.length > 20 &&
                        updatedDataSource?.length <= 30
                      ? ["10", "20", "30"]
                      : updatedDataSource?.length > 30 &&
                        updatedDataSource?.length <= 40
                      ? ["10", "20", "30", "40"]
                      : ["10", "20", "30", "40", "50"],
                  locale: { items_per_page: "" },
                  total: updatedDataSource?.length,
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total}`,
                }
          }
        >
          {/* ${metadata?.show_marker ? '':''} */}
          {updatedTableColumn?.map((col, i) => {
            let columnWidth = col?.title?.length * 8.5 + 51;
            return (
              <Column
                width={
                  PdfDownloadStatus
                    ? ""
                    : col?.title?.toLowerCase()?.includes("text") ||
                      col?.title?.toLowerCase()?.includes("mention")
                    ? "50rem"
                    : col?.title?.toLowerCase()?.includes("bio")
                    ? "30rem"
                    : col?.title?.toLowerCase()?.includes("author")
                    ? "30rem"
                    : `${columnWidth > 150 ? columnWidth : 150}px`
                }
                title={(value) => {
                  let channelImage = col?.title?.split("|$|")?.[0]?.trim();
                  let ProfileName = col?.title?.split("|$|")?.[1]?.trim();
                  let genderName = col?.title?.split("|G|")?.[1]?.trim();
                  let countryName = col?.title?.split("|C|")?.[1]?.trim();
                  return colors && colors[i] !== "#000000" ? (
                    <span
                      style={{
                        color:
                          colors && colors[i] !== "#000000" ? colors[i] : "",
                      }}
                      //className="d-inline-block"
                    >
                      <span>
                        {col?.title?.includes("|$|") ? (
                          <>
                            <img
                              style={{
                                width: "1.5rem",
                                height: "1.5rem",
                                margin: "0.5rem",
                              }}
                              src={
                                channelImage
                                  ? SocialMedialogo?.[channelImage]
                                  : defaultImage
                              }
                            />
                            {ProfileName}
                          </>
                        ) : col?.title?.includes("|G|") ? (
                          <>
                            <img
                              style={{
                                width: "1.5rem",
                                height: "1.5rem",
                                margin: "0.5rem",
                              }}
                              src={getGenderLogo(genderName)}
                            />
                            {genderName}
                          </>
                        ) : col?.title?.includes("|C|") ? (
                          <>
                            {getCountryLogo(countryName)}
                            {countryName}
                          </>
                        ) : (
                          <>
                            {col?.title}{" "}
                            {col?.title === "Unactioned" && (
                              <Tooltip title="These tickets were  created  during the selected duration and are still in agent's queue or are unactioned by the user.">
                                <i className="fa fa-info-circle cursor-pointer ml-1" />
                              </Tooltip>
                            )}
                          </>
                        )}
                      </span>
                    </span>
                  ) : (
                    <>
                      {col?.title}{" "}
                      {col?.title === "Unactioned" && (
                        <Tooltip title="These tickets were  created  during the selected duration and are still in agent's queue or are unactioned by the user.">
                          <i className="fa fa-info-circle cursor-pointer ml-1" />
                        </Tooltip>
                      )}
                    </>
                  );
                }}
                dataIndex={col?.title}
                key={i}
                render={(value, obj, index) => {
                  const updatedObj = {
                    children: value,
                    props: {},
                  };
                  if (
                    rowSpanOn &&
                    (col?.title === rowSpanOn || col?.dataIndex === rowSpanOn)
                  ) {
                    const trueIndex =
                      index +
                      paginationInfo?.pageSize * (paginationInfo?.current - 1);
                    if (
                      index >= 1 &&
                      value === updatedDataSource?.[trueIndex - 1]?.[col?.title]
                    ) {
                      updatedObj.props.rowSpan = 0;
                    } else {
                      for (
                        let i = 0;
                        trueIndex + i !== updatedDataSource?.length &&
                        value ===
                          updatedDataSource?.[trueIndex + i]?.[col?.title];
                        i += 1
                      ) {
                        updatedObj.props.rowSpan = i + 1;
                      }
                      //updatedObj.props.rowSpan = obj?.row_span?.frequency;
                    }
                  } else if (rowSpanOn) {
                    updatedObj.props.className = "text-center";
                  }
                  let channelImage = value?.value
                    ? isString(value?.value) && value?.value?.includes("|$|")
                      ? value?.value?.split("|$|")?.[0]?.trim()
                      : null
                    : isString(value) && value?.includes("|$|")
                    ? value?.split("|$|")?.[0]?.trim()
                    : null;
                  let ProfileName = value?.value
                    ? isString(value?.value) && value?.value?.includes("|$|")
                      ? value?.value?.split("|$|")?.[1]?.trim()
                      : null
                    : isString(value) && value?.includes("|$|")
                    ? value?.split("|$|")?.[1]?.trim()
                    : null;
                  let genderName = value?.value
                    ? isString(value?.value) && value?.value?.includes("|G|")
                      ? value?.value?.split("|G|")?.[1]?.trim()
                      : null
                    : isString(value) && value?.includes("|G|")
                    ? value?.split("|G|")?.[1]?.trim()
                    : null;
                  let countryName = value?.value
                    ? isString(value?.value) && value?.value?.includes("|C|")
                      ? value?.value?.split("|C|")?.[1]?.trim()
                      : null
                    : isString(value) && value?.includes("|C|")
                    ? value?.split("|C|")?.[1]?.trim()
                    : null;
                  updatedObj.children = (
                    <span
                      key={value}
                      style={{
                        maxWidth: "100%",
                      }}
                      className={
                        i === 0
                          ? "d-flex align-items-center word-wrap"
                          : "word-wrap"
                      }
                    >
                      {i === 0 && (
                        <span
                          className="d-none"
                          style={{
                            width: "1rem",
                            height: "1rem",
                            borderRadius: "50%",
                            display: "inline-block",
                            marginRight: "1rem",
                            backgroundColor: "red",
                          }}
                        />
                      )}
                      {graphConditionConfig?.["post-card"]?.key_combinations &&
                      graphConditionConfig?.["post-card"]?.key_combinations?.[
                        col?.title
                      ] ? (
                        getHtmlForThisColumn(
                          graphConditionConfig?.["post-card"]
                            ?.key_combinations?.[col?.title],
                          col,
                          obj,
                          index
                        )
                      ) : col?.title === "Ticket" ? (
                        <>
                          {value > 0 ? (
                            <div
                              className="trands cursor-pointer m-auto"
                              onClick={() =>
                                onExternal(value, obj?.PostBrandID)
                              }
                              style={{ width: "2.5rem" }}
                            >
                              <Tooltip title="Ticket Details">
                                <img
                                  src={deepLinkIcon}
                                  className="cardList__footer-label"
                                  alt="Deep Link Icon"
                                  style={{
                                    maxWidth: "1.8rem",
                                    width: "1.8rem",
                                  }}
                                />
                              </Tooltip>
                            </div>
                          ) : (
                            <div
                              className="trands m-auto"
                              style={{ width: "2.5rem" }}
                            >
                              <Tooltip title="Ticket Details are not available">
                                <img
                                  src={deepLinkIcon}
                                  className="cardList__footer-label gray_scale-filter opacity-half"
                                  alt="Deep Link Icon"
                                  style={{
                                    maxWidth: "1.8rem",
                                    width: "1.8rem",
                                  }}
                                />
                              </Tooltip>
                            </div>
                          )}
                        </>
                      ) : col?.title === "Attachments" ? (
                        <>
                          {value?.length > 0 ? (
                            <div
                              className="trands cursor-pointer m-auto"
                              onClick={() =>
                                showPostDetailsModal(
                                  data?.length > 0 ? data?.[index] : null
                                )
                              }
                              style={{ width: "2.5rem" }}
                            >
                              <Tooltip
                                title={
                                  value?.length > 1
                                    ? "Open Attachments"
                                    : "Open Attachment"
                                }
                              >
                                <img
                                  src={openMediaAttachment}
                                  className="cardList__footer-label"
                                  alt="Attachments"
                                  style={{
                                    maxWidth: "1.8rem",
                                    width: "1.8rem",
                                  }}
                                />
                              </Tooltip>
                            </div>
                          ) : (
                            <div
                              className="trands m-auto"
                              style={{ width: "2.5rem" }}
                            >
                              <Tooltip title={"Attachment not available"}>
                                <img
                                  src={openMediaAttachment}
                                  className="cardList__footer-label gray_scale-filter opacity-half"
                                  alt="Attachments"
                                  style={{
                                    maxWidth: "1.8rem",
                                    width: "1.8rem",
                                  }}
                                />
                              </Tooltip>
                            </div>
                          )}
                        </>
                      ) : col?.title === "Open Post" ? (
                        <Tooltip
                          title={
                            value && value?.trim() && value !== "NA"
                              ? "Open Post"
                              : "Post URL is not available"
                          }
                        >
                          {value && value?.trim() && value !== "NA" ? (
                            <a
                              className={`trands blue-text font-size14 cursor-pointer mr-2`}
                              href={value}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <i class={`fas fa-external-link-alt`} />
                            </a>
                          ) : (
                            <span
                              style={{
                                display: "inline-block",
                                opacity: "0.4",
                              }}
                              className="gray_scale-filter opacity-half font-size14 mr-2"
                            >
                              <i class={`fas fa-external-link-alt`} />
                            </span>
                          )}
                        </Tooltip>
                      ) : col?.title === "Is Verified" ? (
                        <>
                          {value ? (
                            <>
                              <img
                                src={verified}
                                alt="verified"
                                className="profileImg ml-1"
                                style={{ height: "1.6rem" }}
                              />
                              Verified
                            </>
                          ) : (
                            "Not Verified"
                          )}
                        </>
                      ) : col?.title === "Is Promoted Post" ? (
                        <>
                          <Tooltip
                            title={
                              value ? "Promoted Post" : "Not Promoted Post"
                            }
                          >
                            <img
                              alt="is promoted"
                              src={promoted}
                              style={{ width: "2rem", height: "2rem" }}
                              className={`mr-0 ${
                                !value ? "gray_scale-filter opacity-half" : ""
                              }`}
                            />
                          </Tooltip>
                        </>
                      ) : col?.title === "Is Dark Post" ? (
                        <>
                          <span className="trands blue-text font-size14 mr-2">
                            <Tooltip
                              title={value ? "Dark Post" : "Not Dark Post"}
                            >
                              <img
                                alt="is Dark Post"
                                src={IsDarkPost}
                                style={{ width: "1.8rem", height: "1.8rem" }}
                                className={`mr-0 ${
                                  !value ? "gray_scale-filter opacity-half" : ""
                                }`}
                              />
                            </Tooltip>
                          </span>
                        </>
                      ) : (widgetGraphConfig?.chart_settings?.total_row ||
                          metadata?.chart?.chart_settings?.total_row) &&
                        updatedDataSource[updatedDataSource?.length - 1] ===
                          obj &&
                        !widgetDurationComparisonForChart ? (
                        <>
                          <b>{value?.toLocaleString()}</b>
                        </>
                      ) : (
                          dateLabels && Array.isArray(dateLabels)
                            ? dateLabels?.findIndex(
                                (e) => e === col?.title || e === col?.dataIndex
                              ) !== -1
                            : false
                        ) ? (
                        <>{formatDuration(value, "short", 2)}</>
                      ) : typeof value === "object" ? (
                        <>
                          <div className="d-flex flex-direction-column align-items-center">
                            {isString(value?.value) &&
                            value?.value?.includes("|$|") ? (
                              <>
                                <img
                                  style={{
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    margin: "0.5rem",
                                  }}
                                  src={
                                    channelImage
                                      ? SocialMedialogo?.[channelImage]
                                      : defaultImage
                                  }
                                />
                                {ProfileName}
                              </>
                            ) : isString(value?.value) &&
                              value?.value?.includes("|G|") ? (
                              <>
                                <img
                                  style={{
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    margin: "0.5rem",
                                  }}
                                  src={getGenderLogo(genderName)}
                                />
                                {genderName}
                              </>
                            ) : isString(value?.value) &&
                              value?.value?.includes("|C|") ? (
                              <>
                                {getCountryLogo(countryName)}
                                {countryName}
                              </>
                            ) : (
                              <>{value?.value?.toLocaleString()}</>
                            )}
                            {widgetDurationComparisonForChart ? (
                              <span
                                className={`text_regular d-flex align-items-baseline ${
                                  String(value?.text).toLowerCase() ===
                                  String("Negative").toLowerCase()
                                    ? value?.percent_change > 0
                                      ? "negative"
                                      : value?.percent_change < 0
                                      ? "positive"
                                      : "text-gray"
                                    : value?.percent_change > 0
                                    ? "positive"
                                    : value?.percent_change < 0
                                    ? "negative"
                                    : "text-gray"
                                } font-size12`}
                              >
                                {value?.percent_change === null ? (
                                  ""
                                ) : value?.percent_change > 0 ? (
                                  <>
                                    <CaretUpFilled className="font-size18" />
                                    {" " +
                                      Number(
                                        value?.percent_change
                                      )?.toLocaleString() +
                                      "%"}
                                  </>
                                ) : value?.percent_change < 0 ? (
                                  <>
                                    <CaretDownFilled className="font-size18" />
                                    {" " +
                                      Number(
                                        value?.percent_change
                                      )?.toLocaleString() +
                                      "%"}
                                  </>
                                ) : (
                                  value?.percent_change !== null && "NA"
                                )}{" "}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        </>
                      ) : isString(value) && value?.includes("|$|") ? (
                        <>
                          <img
                            style={{
                              width: "1.5rem",
                              height: "1.5rem",
                              margin: "0.5rem",
                            }}
                            src={
                              channelImage
                                ? SocialMedialogo?.[channelImage]
                                : defaultImage
                            }
                          />
                          {ProfileName}
                        </>
                      ) : isString(value) && value?.includes("|G|") ? (
                        <>
                          <img
                            style={{
                              width: "1.5rem",
                              height: "1.5rem",
                              margin: "0.5rem",
                            }}
                            src={getGenderLogo(genderName)}
                          />
                          {genderName}
                        </>
                      ) : isString(value) && value?.includes("|C|") ? (
                        <>
                          {getCountryLogo(countryName)}
                          {countryName}
                        </>
                      ) : (
                        <>
                          {col?.title === "Mention" ? (
                            <>
                              {value?.length > 180
                                ? value?.slice(0, 180)
                                : value}
                              {value?.length > 180 ? (
                                <span
                                  className="blue-text cursor-pointer"
                                  onClick={() =>
                                    showPostDetailsModal(
                                      data?.length > 0 ? data?.[index] : null
                                    )
                                  }
                                >
                                  ... Read More
                                </span>
                              ) : (
                                ""
                              )}
                              {obj?.["Attachments"]?.length > 0 ? (
                                <span
                                  className="trands cursor-pointer"
                                  onClick={() =>
                                    showPostDetailsModal(
                                      data?.length > 0 ? data?.[index] : null
                                    )
                                  }
                                  style={{ width: "2.5rem" }}
                                >
                                  <Tooltip
                                    title={
                                      obj?.["Attachments"]?.length > 1
                                        ? "Open Attachments"
                                        : "Open Attachment"
                                    }
                                  >
                                    <img
                                      src={openMediaAttachment}
                                      className="cardList__footer-label"
                                      alt="Attachments"
                                      style={{
                                        maxWidth: "1.8rem",
                                        width: "1.8rem",
                                      }}
                                    />
                                  </Tooltip>
                                </span>
                              ) : (
                                ""
                              )}
                            </>
                          ) : col?.title?.toLowerCase() === "bio" ? (
                            <>
                              {value?.length > 180
                                ? value?.slice(0, 180)
                                : value}
                              {value?.length > 180 ? (
                                <span
                                  className="blue-text cursor-pointer"
                                  onClick={() =>
                                    showPostDetailsModal(
                                      data?.length > 0 ? data?.[index] : null
                                    )
                                  }
                                >
                                  ... Read More
                                </span>
                              ) : (
                                ""
                              )}
                            </>
                          ) : !isNaN(value) ? (
                            <>
                              <Tooltip title={value?.toLocaleString()}>
                                {kFormatter(value)}
                              </Tooltip>
                            </>
                          ) : value?.toLocaleString() ? (
                            <>{value?.toLocaleString()} </>
                          ) : (
                            "-"
                          )}
                        </>
                      )}
                    </span>
                  );
                  return updatedObj;
                }}
                showSorterTooltip={null} //soting tooltip
                sortDirections={["ascend", "descend"]}
                sorter={PdfDownloadStatus ? null : col?.sorter}
              />
            );
          })}
        </Table>
      )}
      {deepLinkModal?.modalShow && (
        <Modal
          title={null}
          open={deepLinkModal?.modalShow}
          style={{ width: "100%", top: "1rem", paddingBottom: "1rem" }}
          onOk={handleDeepLinkOk}
          onCancel={handleDeepLinkCancel}
          width="100%"
          footer={null}
          className={`deepLinkModal ${
            authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
          }`}
        >
          {!deepLinkModal?.url ? (
            <div
              className="loader mx-auto"
              style={{ height: "calc(100vh - 2.6rem)" }}
            >
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : (
            deepLinkModal?.url
          )}
        </Modal>
      )}
      <PostCardDetails
        data={data}
        modalData={modalData}
        isPreviewState={isPreviewState}
        PdfDownloadStatus={PdfDownloadStatus}
        PptGeneratingStatus={PptGeneratingStatus}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        setIsModalData={setIsModalData}
        isModalLoader={isModalLoader}
        setIsModalLoader={setIsModalLoader}
        isCommandCenterScreen={isCommandCenterScreen}
        // custom_card_settings={custom_card_settings}
        deepDive={deepDive}
        isDeepDiveDashboardView={isDeepDiveDashboardView}
      />
    </div>
  ) : (
    <NoGraphData errorCode="No data found" />
  );
};

export default React.memo(PostCardGrid, isEqual);
